import React, { useState, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useThemeMode } from '../ThemeContext';

import LancherixIcon from '../icons/lancherix.svg';
import LancherixDarkIcon from '../icons/lancherixDark.svg';
import SearchIcon from '../icons/search.svg';
import SearchDarkIcon from '../icons/searchDark.svg';

import './Styles/SearchBar.css';

const SearchBar = ({ onSearch }) => {
  const { t } = useTranslation();
  const { themeMode, resolvedTheme } = useThemeMode();
  const [query, setQuery] = useState('');

  // ─────────────────────────────────────────────
  // Debounced search (users + projects)
  // ─────────────────────────────────────────────
  const debouncedSearch = useCallback(() => {
    let timeout;

    return (value) => {
      clearTimeout(timeout);

      timeout = setTimeout(async () => {
        if (!value) {
          onSearch({ users: [], projects: [] });
          return;
        }

        try {
          const token = localStorage.getItem('token');

          const [usersRes, projectsRes] = await Promise.all([
            fetch(
              `https://lancherixstudio-backend.onrender.com/api/users/search?query=${value}`
            ),
            fetch(
              `https://lancherixstudio-backend.onrender.com/api/projects/search?query=${value}`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            ),
          ]);

          if (!usersRes.ok || !projectsRes.ok) {
            throw new Error('Search failed');
          }

          const users = await usersRes.json();
          const projects = await projectsRes.json();

          onSearch({ users, projects });
        } catch (err) {
          console.error('Search error:', err);
          onSearch({ users: [], projects: [] });
        }
      }, 400);
    };
  }, [onSearch])();

  // ─────────────────────────────────────────────
  // Input handler
  // ─────────────────────────────────────────────
  const handleInputChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    debouncedSearch(value);
  };

  return (
    <div className="all-searchBar">
      <div className="search-searchBar">
        <img
          src={
            resolvedTheme === 'dark' || resolvedTheme === 'glass'
              ? LancherixDarkIcon
              : LancherixIcon
          }
          alt="Lancherix"
          className="icon-searchBar iconOn-searchBar"
        />

        <input
          type="text"
          value={query}
          onChange={handleInputChange}
          placeholder={t('lancherixSearchPlaceholder')}
          spellCheck={false}
        />
        <img
          src={
            resolvedTheme === 'dark' || resolvedTheme === 'glass'
              ? SearchDarkIcon
              : SearchIcon
          }
          alt="Search"
          className="icon-searchBar iconOn-searchBar iconRight-searchBar"
        />
      </div>
    </div>
  );
};

export default SearchBar;